import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getHelpCenterTopBarSplitFlag } from 'state/selectors/help-center';
import BreadcrumbsElement from './breadcrumbs-element';

const selector = createSelector(getHelpCenterTopBarSplitFlag, (hasTopBarBeenSplit) => ({
	hasTopBarBeenSplit,
}));

export default connect(selector, {})(BreadcrumbsElement);
